import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconNotEligibleFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M24.556 5A2.444 2.444 0 0 1 27 7.444v17.112A2.444 2.444 0 0 1 24.556 27H7.444A2.444 2.444 0 0 1 5 24.556V7.444A2.444 2.444 0 0 1 7.444 5zm-4.025 6.47a1.22 1.22 0 0 0-1.728 0l-7.334 7.333a1.222 1.222 0 1 0 1.729 1.728l7.333-7.333a1.22 1.22 0 0 0 0-1.729" clipRule="evenodd" /></svg>;
export default SvgIconNotEligibleFilledSmall;